import * as yup from 'yup';

export const getAppDetailsFormSchema = () => {
  return yup.object().shape({
    categoriesIds: yup
      .array()
      .test(
        'Categories ids test',
        'Please select at least 1 category !',
        value => !!value?.length
      )
      .required(),
    countriesRegionsIds: yup
      .array()
      .test(
        'Countries regions ids test',
        'Please select at least 1 region !',
        value => !!value?.length
      )
      .required(),
    defaultLanguageIso: yup
      .object()
      .nullable()
      .required('Please select at least one default language !'),
    longDescription: yup
      .string()
      .max(4000, 'Maximum 4000 characters.')
      .required('Please add a long description !'),
    name: yup
      .string()
      .max(30, 'Maximum 30 characters.')
      .required('Please add an app name !'),
    privacyPolicy: yup.string().required('Please add a privacy policy url !'),
    publisherName: yup.string().required('Please add a publisher name !'),
    iconId: yup
      .number()
      .nullable()
      .typeError('Please add one icon !')
      .test('Icon id test', 'Please add one icon !', value => !!value)
      .required(),
    screenshotsIds: yup
      .array()
      .min(1, 'Please add at least one screenshot !')
      .required(),
    shortDescription: yup
      .string()
      .max(100, 'Maximum 100 characters.')
      .required('Please add a short description !'),
    website: yup.string(),
    packageName: yup.string().required('Please add a package name !'),
    isFeatured: yup.boolean(),
  });
};
